/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var app = angular.module('asc718', []);
	function asc718($scope, $window, $document) {
	    $scope.sendMail = function (email, subject, message) {
	        analytics.track('clicked learn more on ASC-718 marketing page');
	        $window.open("mailto:" + email + "?subject=" + subject + "&body=" + message, "_self");
	    };
	    $scope.enlargeDisclosure = false;
	    $scope.enlargeJournal = false;
	    $scope.enlargeValuation = false;
	    angular.element($window).bind("scroll", function () {
	        var disclosureTableY = angular.element($document).find('disclosure-table')[0].getBoundingClientRect().top;
	        var journalTableY = angular.element($document).find('journal-table')[0].getBoundingClientRect().top;
	        var valuationTableY = angular.element($document).find('valuation-table')[0].getBoundingClientRect().top;
	        if (disclosureTableY < $window.innerHeight) {
	            $scope.enlargeDisclosure = true;
	        }
	        if (journalTableY < $window.innerHeight) {
	            $scope.enlargeJournal = true;
	        }
	        if (valuationTableY < $window.innerHeight) {
	            $scope.enlargeValuation = true;
	        }
	        $scope.$apply();
	    });
	}
	function disclosureTable() {
	    return {
	        restrict: 'E',
	        template: __webpack_require__(1032)
	    };
	}
	function journalTable() {
	    return {
	        restrict: 'E',
	        template: __webpack_require__(1033)
	    };
	}
	function valuationTable() {
	    return {
	        restrict: 'E',
	        template: __webpack_require__(1034)
	    };
	}
	app.controller('asc718', asc718).directive('disclosureTable', disclosureTable).directive('journalTable', journalTable).directive('valuationTable', valuationTable);

/***/ }),

/***/ 1032:
/***/ (function(module, exports) {

	module.exports = "<table ng-class=\"{'hi-fi' : enlargeDisclosure}\">\n    <tr>\n        <th></th>\n        <th>Available for Grant</th>\n        <th>Activity</th>\n        <th>Number of Shares Outstanding</th>\n        <th>Weighted Average Exercise Price</th>\n        <th>Weighted Average Remaining Contractual Term (Years)</th>\n        <th>Aggregate intrinsic Value</th>\n    </tr>\n    <tr>\n        <td>Outstanding - December 31, 2012</td>\n        <td>660,182</td>\n        <td></td>\n        <td>1,632,602</td>\n        <td>$0.022</td>\n        <td>8.67</td>\n        <td>$28,852</td>\n    </tr>\n    <tr>\n        <td></td>\n        <td></td>\n        <td></td>\n        <td></td>\n        <td></td>\n        <td></td>\n        <td></td>\n    </tr>\n    <tr>\n        <td>Authorized</td>\n        <td>514,620</td>\n        <td></td>\n        <td></td>\n        <td></td>\n        <td></td>\n        <td></td>\n    </tr>\n    <tr>\n        <td>Granted</td>\n        <td></td>\n        <td>1,023,792</td>\n        <td></td>\n        <td>$0.294</td>\n        <td></td>\n        <td></td>\n    </tr>\n    <tr>\n        <td>Exercised</td>\n        <td></td>\n        <td>(617,204)</td>\n        <td></td>\n        <td>$0.034</td>\n        <td></td>\n        <td></td>\n    </tr>\n    <tr>\n        <td>Forfeited</td>\n        <td></td>\n        <td>(355,837)</td>\n        <td></td>\n        <td>$0.043</td>\n        <td></td>\n        <td></td>\n    </tr>\n    <tr>\n        <td></td>\n        <td></td>\n        <td></td>\n        <td></td>\n        <td></td>\n        <td></td>\n        <td></td>\n    </tr>\n    <tr>\n        <td>Outstanding - December 31, 2013</td>\n        <td>506,847</td>\n        <td></td>\n        <td>1,683,353</td>\n        <td>$0.179</td>\n        <td>8.92</td>\n        <td>$187,394</td>\n    </tr>\n</table>\n"

/***/ }),

/***/ 1033:
/***/ (function(module, exports) {

	module.exports = "<table ng-class=\"{'hi-fi' : enlargeJournal}\">\n    <tr>\n        <th>Grant Journal Entries</th>\n        <th>For Fiscal Year Ended December 31, 2013</th>\n    </tr>\n    <tr>\n        <td>Dr. Compensation Cost - Executive</td>\n        <td>$120,843</td>\n    </tr>\n    <tr>\n        <td>Dr. Compensation Cost - Marketing</td>\n        <td>$25,930</td>\n    </tr>\n    <tr>\n        <td>Dr. Compensation Cost - Engineering</td>\n        <td>$78,230</td>\n    </tr>\n    <tr>\n        <td>Dr. Compensation Cost - Sales</td>\n        <td>$25,887</td>\n    </tr>\n    <tr>\n        <td>Cr. Paid-in Capital from stock options</td>\n        <td>$250,890</td>\n    </tr>\n    <tr>\n        <td></td>\n        <td></td>\n    </tr>\n    <tr>\n        <td>Exercise Journal Entries</td>\n        <td>June 2014 Exercise</td>\n    </tr>\n    <tr>\n        <td>Cash</td>\n        <td>$700,000</td>\n    </tr>\n    <tr>\n        <td>Paid-in Capital from Stock Options</td>\n        <td>$94,390</td>\n    </tr>\n    <tr>\n        <td>Common Stock ($0.0001 Par)</td>\n        <td>$20</td>\n    </tr>\n    <tr>\n    <td>Paid-in capital in excess of par</td>\n        <td>$794,370</td>\n    </tr>\n</table>\n"

/***/ }),

/***/ 1034:
/***/ (function(module, exports) {

	module.exports = "<table ng-class=\"{'hi-fi' : enlargeValuation}\">\n    <tr>\n        <th>For Fiscal Year Ended December 31</th>\n        <th>2012</th>\n        <th>2013</th>\n        <th>2014</th>\n        <th>2015</th>\n    </tr>\n    <tr>\n        <td>Expected term (in years)</td>\n        <td>6.1 - 7.1</td>\n        <td>6.1 - 8.2</td>\n        <td>5.3 - 7.3</td>\n        <td>5.0 - 6.9</td>\n    </tr>\n    <tr>\n        <td>Expected volatility</td>\n        <td>70% - 80%</td>\n        <td>65% - 75%</td>\n        <td>65% - 69%</td>\n        <td>55% - 68%</td>\n    </tr>\n    <tr>\n        <td>Risk-free interest rate</td>\n        <td>0.5% - 2.5%</td>\n        <td>0.6% - 2.0%</td>\n        <td>0.8% - 2.1%</td>\n        <td>1.3% - 2.2%</td>\n    </tr>\n    <tr>\n        <td>Dividend rate</td>\n        <td>0</td>\n        <td>0</td>\n        <td>0</td>\n        <td>0</td>\n    </tr>\n    <tr>\n        <td>Fair value of common stock</td>\n        <td>$0.25 - $0.87</td>\n        <td>$0.87 - $1.30</td>\n        <td>$1.46 - $2.98</td>\n        <td>$4.81 - $12.65</td>\n    </tr>\n</table>\n"

/***/ })

/******/ });


// WEBPACK FOOTER //
// asc718.min.js